<script lang="ts">
	import ScrollDetector from '$lib/scrollDetector.svelte';
	import { footerOrNewsletterFormVisible } from '$lib/stores/footer';
	import { fly } from 'svelte/transition';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			always_visible: boolean;
			visible_after_hero: boolean;
			title: string;
			subtitle: string;
			cta: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let heroElement: HTMLElement | null = $state(null);

	let shouldShow = $state(content.always_visible);
	let show = $derived(shouldShow && !$footerOrNewsletterFormVisible);

	function handleScroll(y: number) {
		const heroHeight = heroElement?.clientHeight || 0;

		shouldShow = y > heroHeight;
	}

	$effect(() => {
		heroElement = document.getElementById('hero');
	});
</script>

<div use:editable={content} data-testid="sticky-footer-wrapper" class="empty:hidden">
	<ScrollDetector
		throttle={!content.always_visible && !content.visible_after_hero ? 150 : undefined}
		duration={!content.always_visible && !content.visible_after_hero ? 200 : undefined}
		onstart={!content.always_visible && !content.visible_after_hero
			? () => (shouldShow = true)
			: undefined}
		onscroll={content.visible_after_hero ? handleScroll : undefined}
	/>

	{#if show}
		<section
			class="fixed inset-x-0 bottom-0 z-[70] flex items-center justify-between gap-x-2 border border-t-brown-5 bg-white px-5 pb-7 pt-3 lg:hidden"
			transition:fly={{ y: 120 }}
		>
			<div>
				<h1 class="mb-1 text-[1rem]/[110%] font-semibold text-black">{content.title}</h1>
				<p class="text-[14px]/[160%] text-brown-4">{content.subtitle}</p>
			</div>
			{#if content.cta?.length > 0}
				<Blok content={content.cta[0]} />
			{/if}
		</section>
	{/if}
</div>
